/* global React, Icon, Card, CardHead, Button, IconButton, Field, Input, Select, Currency, Segmented, Tabs, Badge, StatusBadge, KPI, Modal, EmptyState, Pagination, FilterPanel, makeFilter, dateInFilter, toast, SectionTitle, BusinessRegistryLookup, BusinessRegistryToggle, useBusinessRegistryToggle, INVOICES, CUSTOMERS, SUPPLIERS, DataList, fmt, fmt0, signedAmountColor */
// PLUMME 2.0 — Kunder (customer list, detail, modal)
function ImportedCustomerOpenItems({ items }) { return <ImportedAccountingOpenItems items={items} kind="customer" />; }
const customerNetBalanceMeta = (amount) => {
  const value = Math.round(Number(amount) || 0);
  if (value > 0) return { state: 'receivable', text: t('cust.balance.customerOwes', { amount: fmt(value) }), tone: 'var(--warning)' };
  if (value < 0) return { state: 'credit', text: t('cust.balance.youOwe', { amount: fmt(Math.abs(value)) }), tone: 'var(--success)' };
  return { state: 'settled', text: t('cust.balance.settled'), tone: 'var(--ink)' };
};
const customerDate = (value) => (typeof PlummeI18n !== 'undefined' && typeof PlummeI18n.formatDate === 'function') ? PlummeI18n.formatDate(value) : (typeof value === 'string' && value.split('-').length === 3 ? `${value.split('-')[2]}.${value.split('-')[1]}.${value.split('-')[0]}` : value || '');
function CustomerLedgerTable({ customer }) {
  const rows = buildCustomerLedgerRows([customer]);
  const displayRows = rows.map((row, index) => ({ ...row, ledgerRowKey: `${row.date || ''}-${row.doc || ''}-${row.type || ''}-${row.balance || 0}-${index}` }));
  return <div className="cust-ledger-panel">
    <strong className="t-h3" style={{ display: 'block', fontSize: 15, marginBottom: 12 }}>{t('cust.ledgerShort')}</strong>
    {rows.length === 0 ? <div className="t-sm muted" style={{ padding: '14px 2px', fontWeight: 600 }}>{t('cust.ledger.empty')}</div> :
      <DataList tableClass="cust-ledger-table" rows={displayRows} rowKey={(row) => row.ledgerRowKey} pageSize={10} columns={[
        { header: t('cust.ledger.date'), thClass: 'ledger-date-col', cellClass: 't-sm muted ledger-date-col', sort: (row) => row.sortDate || row.date || '', render: (row) => row.date || '-' },
        { header: t('cust.ledger.doc'), thClass: 'ledger-doc-col', cellClass: 't-sm muted ledger-doc-col', sort: (row) => row.doc || '', render: (row) => row.doc || '-' },
        { header: t('cust.ledger.type'), sort: (row) => row.type || '', render: (row) => <div className="t-sm" style={{ fontWeight: 800 }}>{row.type}<div className="ledger-date-inline muted">{row.date ? `${t('cust.ledger.date')}: ${row.date}` : ''}</div><div className="ledger-doc-inline muted">{row.doc ? `${t('cust.ledger.doc')}: ${row.doc}` : ''}</div></div> },
        { header: t('cust.ledger.debit'), headerRight: true, thClass: 'ledger-debit-col', cellClass: 'num ledger-debit-col', tdStyle: (row) => ({ color: row.debit ? 'var(--success)' : 'var(--ink)' }), sort: (row) => Number(row.debit) || 0, render: (row) => row.debit ? fmt(row.debit) : '' },
        { header: t('cust.ledger.credit'), headerRight: true, thClass: 'ledger-credit-col', cellClass: 'num ledger-credit-col', tdStyle: (row) => ({ color: row.credit ? 'var(--error)' : 'var(--ink)' }), sort: (row) => Number(row.credit) || 0, render: (row) => row.credit ? fmt(row.credit) : '' },
        { header: t('cust.ledger.balance'), headerRight: true, cellClass: 'num', tdStyle: (row) => ({ color: signedAmountColor(row.balance) }), sort: (row) => Number(row.balance) || 0, render: (row) => fmt(row.balance) },
        { header: t('cust.export.status'), cellClass: 't-sm muted', sort: (row) => row.status || '', render: (row) => row.status },
      ]} />}
  </div>;
}
function CustomerDetail({ c, onDelete, onEdit, onChat, onMerge, setRoute }) {
  const [f, setF] = useState('all');
  const [tab, setTab] = useState('sales');
  const [page, setPage] = useState(1);
  const [pdfPreview, setPdfPreview] = useState(null);
  const [pdfBusy, setPdfBusy] = useState(null);
  const [actMenu, setActMenu] = useState(false);
  const invoices = Array.isArray(window.INVOICES) ? window.INVOICES : (typeof INVOICES !== 'undefined' ? INVOICES : []);
  const all = invoices.filter((i) => i.customer === c.name && i.type !== 'tilbud');
  const payOf = (i) => i.type === 'kreditnota' ? 'credit' : i.status === 'betalt' ? 'paid' : 'unpaid';
  const shown = all.filter((i) => { const p = payOf(i); return f === 'all' || (f === 'unpaid' && p === 'unpaid') || (f === 'paid' && p === 'paid'); });
  const total = shown.reduce((s, i) => s + i.amount, 0);
  const PER_PAGE = 10;
  const pages = Math.max(1, Math.ceil(shown.length / PER_PAGE));
  const curPage = Math.min(page, pages);
  const pageRows = shown.slice((curPage - 1) * PER_PAGE, curPage * PER_PAGE);
  const acts = (c.activities || []).slice().sort((a, b) => b.date.localeCompare(a.date)).slice(0, 4);
  const payLabel = { paid: t('cust.salesPaid'), unpaid: t('cust.salesUnpaid'), credit: t('cust.creditNote') };
  const payCls = { paid: 'pp-paid', unpaid: 'pp-unpaid', credit: 'pp-credit' };
  const balanceMeta = customerNetBalanceMeta(c.out);
  const createInvoiceForCustomer = () => {
    window.PlummeBackend?.setOpenInvoice?.({ customer: c.name, customerId: c.id, _backend: { customer: c._backend || c, customerId: c.id } });
    setRoute && setRoute('faktura');
  };
  const openInvoice = (invoice) => {
    window.__plummeInvoiceListTab = invoice.type === 'kreditnota' ? 'kreditnota' : 'faktura';
    window.__highlightInvoice = invoice.id || invoice.num;
    setRoute && setRoute('fakturaliste');
  };
  const closePdf = () => {
    if (pdfPreview?.objectUrl && pdfPreview.src) URL.revokeObjectURL(pdfPreview.src);
    setPdfPreview(null);
  };
  return <div className="cust-detail">
    <div className="cust-crm" data-help-title={t('cust.followUp')} data-help={t('cust.followUpHelp')}>
      <div className="row between" style={{ marginBottom: 12 }}>
        <strong className="t-h3" style={{ fontSize: 15 }}>{t('cust.followUp')}</strong>
        <Button size="sm" variant="secondary" icon="mail" data-help-title={t('cust.dialogTitle')} data-help={t('cust.dialogHelp')} onClick={(e) => { e.stopPropagation(); onChat && onChat(); }}>{c.activities ? t('cust.openChat') : t('cust.startChat')}</Button>
      </div>
      <div className="cust-crm-grid">
        <div><div className="t-sm muted" style={{ fontWeight: 700 }}>{t('cust.nextFollowUp')}</div><div className="t-h3" style={{ fontSize: 14 }}>{c.followUp ? customerDate(c.followUp) : t('cust.noFollowUpDate')}</div></div>
        <div><div className="t-sm muted" style={{ fontWeight: 700 }}>{t('cust.status')}</div><div style={{ marginTop: 3 }}>{crmBadge(c)}</div></div>
      </div>
      {c.defaultCustomerReference && <p className="cust-note"><b>{t('cust.form.defaultRef')}:</b> {c.defaultCustomerReference}</p>}
      {c.note && <p className="cust-note">{c.note}</p>}
      {acts.length > 0 && <div className="cust-acts">{acts.map((a, i) => <div key={i} className="cust-act"><span className="t-xs muted">{customerDate(a.date)}</span><p>{a.text}</p></div>)}</div>}
    </div>
    <div className="cust-sales" data-help-title={t('cust.salesTitle')} data-help={t('cust.salesHelp')}>
      <div className="row between wrap gap-10" style={{ marginBottom: 12 }}>
        <div className="seg-mini">{[['sales', t('cust.salesTitle')], ['ledger', t('cust.ledgerShort')]].map(([key, label]) => <button key={key} className={tab === key ? 'active' : ''} onClick={(e) => { e.stopPropagation(); setTab(key); }}>{label}</button>)}</div>
        <span className="pp" style={{ background: 'var(--panel)', color: balanceMeta.tone, borderColor: 'var(--border-strong)' }}>{balanceMeta.text}</span>
      </div>
      {tab === 'ledger' ? <CustomerLedgerTable customer={c} /> : <React.Fragment>
      <div className="row between wrap gap-10" style={{ marginBottom: 12 }}>
        <div className="seg-mini">{[['all', t('cust.salesAll')], ['unpaid', t('cust.salesUnpaid')], ['paid', t('cust.salesPaid')]].map(([k, l]) => <button key={k} className={f === k ? 'active' : ''} onClick={(e) => { e.stopPropagation(); setF(k); setPage(1); }}>{l}</button>)}</div>
        <div className="t-sm muted" style={{ fontWeight: 700 }}>{t('cust.salesTotal')} <b style={{ color: 'var(--ink)' }}>{fmt(total)}</b></div>
      </div>
      {shown.length === 0 ? <div className="t-sm muted" style={{ padding: '14px 2px', fontWeight: 600 }}>{t('cust.noSalesMatch')}</div> :
        <React.Fragment><div className="col gap-8">{pageRows.map((i) => { const p = payOf(i); return <div key={i.id} className="cust-sale-row">
          <div className="row gap-10" style={{ minWidth: 0, flex: 1 }}><span className="icon-chip" style={{ background: 'var(--panel)', width: 30, height: 30 }}><Icon name={i.type === 'kreditnota' ? 'files' : 'fileText'} size={16} /></span>
            <div style={{ minWidth: 0 }}><div className="t-h3" style={{ fontSize: 13.5 }}>{i.type === 'kreditnota' ? t('cust.creditNote') : t('cust.invoice')} #{i.num} <span className="muted" style={{ fontWeight: 600 }}>· {i.date}</span></div>
              <div className="t-xs muted">{t('cust.dueOn', { date: i.due })}</div></div></div>
          <div className="row gap-10 cust-sale-right" style={{ flex: 'none' }}><span className="cust-sale-amt"><b className="t-num" style={{ fontSize: 13.5, color: signedAmountColor(i.amount) }}>{fmt(i.amount)}</b>
            <span className={'pp ' + payCls[p]}>{payLabel[p]}</span></span>
            <Button size="sm" variant="secondary" icon="eye" disabled={pdfBusy === i.id} onClick={(e) => { e.stopPropagation(); openInvoice(i); }}>{t('cust.open')}</Button></div>
        </div>; })}</div>
        {pages > 1 && <div className="row between" style={{ marginTop: 12, alignItems: 'center' }}>
          <span className="t-sm muted">{t('cust.pageRange', { from: (curPage - 1) * PER_PAGE + 1, to: Math.min(curPage * PER_PAGE, shown.length), total: shown.length })}</span>
          <div className="row gap-6">
            <IconButton name="chevLeft" size="sm" variant="ghost" onClick={(e) => { e.stopPropagation(); setPage(Math.max(1, curPage - 1)); }} aria-label={t('cust.prev')} />
            <span className="t-sm" style={{ fontWeight: 800, alignSelf: 'center' }}>{curPage} / {pages}</span>
            <IconButton name="chevRight" size="sm" variant="ghost" onClick={(e) => { e.stopPropagation(); setPage(Math.min(pages, curPage + 1)); }} aria-label={t('cust.next')} />
          </div>
        </div>}</React.Fragment>}
      </React.Fragment>}
    </div>
    <ImportedCustomerOpenItems items={c.importedOpenItems} />
    {(() => { const acts = [
      { label: t('cust.act.newInvoice'), icon: 'fileText', variant: 'secondary', help: t('cust.act.newInvoiceHelp'), onClick: (e) => { e && e.stopPropagation && e.stopPropagation(); createInvoiceForCustomer(); } },
      { label: t('cust.act.edit'), icon: 'pencil', variant: 'secondary', help: t('cust.act.editHelp'), onClick: (e) => { e && e.stopPropagation && e.stopPropagation(); onEdit && onEdit(); } },
      { label: t('cust.act.merge'), icon: 'swap', variant: 'secondary', help: t('cust.act.mergeHelp'), onClick: (e) => { e && e.stopPropagation && e.stopPropagation(); onMerge && onMerge(); } },
      { label: t('cust.act.archive'), icon: 'trash', variant: 'danger', help: t('cust.act.archiveHelp'), onClick: (e) => { e && e.stopPropagation && e.stopPropagation(); onDelete(); } },
    ]; return <React.Fragment>
      <div className="row gap-10 wrap kdr-acts-inline" style={{ justifyContent: 'flex-end' }}>{acts.map((a, i) => <Button key={i} size="sm" variant={a.variant} icon={a.icon} data-help-title={a.label} data-help={a.help} onClick={a.onClick}>{a.label}</Button>)}</div>
      <div className="kdr-acts-menu popwrap">
        <button className="btn btn-secondary" style={{ width: '100%', justifyContent: 'center' }} onClick={(e) => { e.stopPropagation(); setActMenu((o) => !o); }}><Icon name="sliders" size={16} />{t('cust.act.menu')}<Icon name={actMenu ? 'chevDown' : 'chevUp'} size={15} /></button>
        {actMenu && <React.Fragment><div className="pop-scrim" onClick={(e) => { e.stopPropagation(); setActMenu(false); }} /><div className="pop pop-menu" style={{ bottom: 'calc(100% + 8px)', top: 'auto', left: 0, right: 0 }}>{acts.map((a, i) => <button key={i} onClick={(e) => { a.onClick(e); setActMenu(false); }} style={a.variant === 'danger' ? { color: 'var(--error)' } : null}><Icon name={a.icon} size={18} />{a.label}</button>)}</div></React.Fragment>}
      </div>
    </React.Fragment>; })()}
    {pdfPreview && <Modal open onClose={closePdf} max={920} title={(pdfPreview.invoice?.num || t('cust.invoice')) + '.pdf'}
      footer={<Button variant="ghost" onClick={closePdf}>{t('common.close')}</Button>}>
      <PdfViewer src={pdfPreview.src} name={pdfPreview.name || ((pdfPreview.invoice?.num || 'faktura') + '.pdf')} />
    </Modal>}
  </div>;
}
// Kolonnene bygges ved eksport, ikke ved lasting, slik at overskriftene følger
// språket brukeren har valgt akkurat nå. De engelske overskriftene er valgt slik
// at de normaliserer til aliasene `parseCustomerMatrix` under allerede godtar —
// en eksportert fil kan derfor importeres tilbake uansett språk.
const customerExportColumns = () => [
  { header: t('cust.export.number'), value: (c) => c.nr || '' },
  { header: t('cust.export.name'), value: (c) => c.name || '' },
  { header: t('cust.export.org'), value: (c) => c.org || '' },
  { header: t('cust.export.email'), value: (c) => c.email || '' },
  { header: t('cust.export.phone'), value: (c) => c.phone || '' },
  { header: t('cust.export.address'), value: (c) => c.addr || '' },
  { header: t('cust.export.zip'), value: (c) => c.zip || '' },
  { header: t('cust.export.city'), value: (c) => c.city || '' },
  { header: t('cust.export.status'), value: (c) => c.crm || 'aktiv' },
  { header: t('cust.export.followUp'), value: (c) => c.followUp || '' },
  { header: t('cust.export.defaultRef'), value: (c) => c.defaultCustomerReference || '' },
  { header: t('cust.export.note'), value: (c) => c.note || '' },
];
const customerLedgerColumns = () => [
  { header: t('cust.ledger.code'), value: (r) => r.code },
  { header: t('cust.export.name'), value: (r) => r.name },
  { header: t('cust.export.org'), value: (r) => r.org },
  { header: t('cust.ledger.date'), value: (r) => r.date },
  { header: t('cust.ledger.doc'), value: (r) => r.doc },
  { header: t('cust.ledger.type'), value: (r) => r.type },
  { header: t('cust.ledger.due'), value: (r) => r.due },
  { header: t('cust.ledger.debit'), value: (r) => r.debit },
  { header: t('cust.ledger.credit'), value: (r) => r.credit },
  { header: t('cust.ledger.balance'), value: (r) => r.balance },
  { header: t('cust.ledger.paid'), value: (r) => r.paid },
  { header: t('cust.ledger.remaining'), value: (r) => r.remaining },
  { header: t('cust.export.status'), value: (r) => r.status },
];
const csvCell = (value) => String(value ?? '').trim();
const splitCsvLine = (line, delimiter) => {
  const cells = [];
  let current = '';
  let quoted = false;
  for (let i = 0; i < line.length; i += 1) {
    const ch = line[i];
    if (ch === '"' && line[i + 1] === '"') { current += '"'; i += 1; continue; }
    if (ch === '"') { quoted = !quoted; continue; }
    if (ch === delimiter && !quoted) { cells.push(current); current = ''; continue; }
    current += ch;
  }
  cells.push(current);
  return cells.map(csvCell);
};
const normalizeCustomerImportHeader = (header) => String(header || '').toLowerCase().replace(/\s|\.|-/g, '');
const parseCustomerMatrix = (matrix) => {
  if (!Array.isArray(matrix) || matrix.length < 2) return [];
  const headers = matrix[0].map(normalizeCustomerImportHeader);
  const pick = (row, names) => {
    const index = headers.findIndex((header) => names.includes(header));
    return index >= 0 ? row[index] || '' : '';
  };
  return matrix.slice(1).map((row) => {
    const address1 = pick(row, ['adresse', 'adresse1', 'address', 'address1']);
    const address2 = pick(row, ['adresse2', 'address2']);
    return {
      nr: pick(row, ['kundenr', 'kundenummer', 'customernumber', 'no']),
      name: pick(row, ['navn', 'kundenavn', 'name', 'customer']),
      org: pick(row, ['orgnr', 'organisasjonsnummer', 'orgno', 'organizationnumber']),
      email: pick(row, ['epost', 'e-post', 'email']),
      phone: pick(row, ['telefon', 'mobil', 'mobile', 'phone']),
      addr: [address1, address2].filter(Boolean).join(', '),
      zip: pick(row, ['postnr', 'postalcode', 'zip']),
      city: pick(row, ['poststed', 'postalplace', 'city']),
      crm: pick(row, ['status', 'kundestatus', 'crm']) || 'aktiv',
      followUp: pick(row, ['nesteoppfølging', 'nesteoppfolging', 'followup']),
      note: pick(row, ['notat', 'note']),
      defaultCustomerReference: pick(row, ['fastreferanse', 'fakturareferanse', 'deresreferanse', 'defaultcustomerreference', 'customerreference']),
    };
  }).filter((customer) => customer.name);
};
const parseCustomerCsv = (text) => {
  const clean = String(text || '').replace(/^\uFEFF/, '');
  const lines = clean.split(/\r?\n/).filter((line) => line.trim());
  if (lines.length < 2) return [];
  const delimiter = (lines[0].match(/;/g) || []).length >= (lines[0].match(/,/g) || []).length ? ';' : ',';
  return parseCustomerMatrix(lines.map((line) => splitCsvLine(line, delimiter)));
};
const parseCustomerXlsx = async (file) => {
  await loadXLSX().catch(() => {});
  if (!window.XLSX) throw new Error(t('cust.error.xlsxImport'));
  const workbook = window.XLSX.read(await file.arrayBuffer(), { type: 'array' });
  const sheetName = workbook.SheetNames?.[0];
  if (!sheetName) return [];
  const matrix = window.XLSX.utils.sheet_to_json(workbook.Sheets[sheetName], { header: 1, raw: false, defval: '' });
  return parseCustomerMatrix(matrix);
};
const exportRowsXlsx = async (filename, columns, rows, sheetName) => {
  await loadXLSX().catch(() => {});
  if (!window.XLSX) throw new Error(t('cust.error.xlsxExport'));
  const matrix = [
    columns.map((column) => column.header),
    ...rows.map((row) => columns.map((column) => column.value(row))),
  ];
  const workbook = window.XLSX.utils.book_new();
  const worksheet = window.XLSX.utils.aoa_to_sheet(matrix);
  window.XLSX.utils.book_append_sheet(workbook, worksheet, sheetName);
  window.XLSX.writeFile(workbook, `${filename}.xlsx`);
};
const invoiceBelongsToCustomerUi = (invoice, customer) => {
  const backend = invoice._backend || {};
  const invCustomer = backend.customer || {};
  if (customer.nr && invCustomer.customerNumber) return customer.nr === invCustomer.customerNumber;
  if (customer.org && invCustomer.organizationNumber) return customer.org === invCustomer.organizationNumber;
  if (customer.email && invCustomer.email) return customer.email.toLowerCase() === String(invCustomer.email).toLowerCase();
  return String(invoice.customer || invCustomer.name || '').trim().toLowerCase() === String(customer.name || '').trim().toLowerCase();
};
const buildCustomerLedgerRows = (customers) => {
  const invoices = Array.isArray(window.INVOICES) ? window.INVOICES : [];
  const rows = [];
  customers.forEach((customer) => {
    let balance = 0;
    const entries = [];
    invoices
      .filter((invoice) => !invoice.draft && invoice.type !== 'tilbud' && invoice.type !== 'ordre' && invoiceBelongsToCustomerUi(invoice, customer))
      .sort((a, b) => String(a._backend?.date || a.date).localeCompare(String(b._backend?.date || b.date)))
      .forEach((invoice) => {
        const isCredit = invoice.type === 'kreditnota';
        const gross = Math.abs(Number(invoice.amount) || 0);
        const debit = isCredit ? 0 : gross;
        const credit = isCredit ? gross : 0;
        entries.push({
          sortDate: invoice._backend?.date || invoice.date || '',
          code: customer.nr || customer.id,
          name: customer.name,
          org: customer.org || '',
          date: invoice._backend?.date || invoice.date || '',
          doc: invoice.num || invoice.id,
          type: isCredit ? t('cust.creditNote') : t('cust.invoice'),
          due: invoice._backend?.dueDate || invoice.due || '',
          debit: debit || '',
          credit: credit || '',
          balance,
          paid: isCredit ? '' : invoice.paidAmount || '',
          remaining: isCredit ? '' : invoice.remainingAmount || '',
          status: isCredit ? t('cust.creditNote') : invoice.paymentStatus === 'paid' ? t('cust.salesPaid') : invoice.paymentStatus === 'partial' ? t('cust.ledger.partial') : t('cust.ledger.unpaid'),
        });
        (invoice.payments || []).forEach((payment) => {
          if (payment.status === 'reversed') return;
          const amount = Math.abs(Number(payment.amount) || 0);
          const outgoing = payment.direction === 'outgoing' || payment._backend?.direction === 'outgoing';
          entries.push({
            sortDate: payment.date || '',
            code: customer.nr || customer.id,
            name: customer.name,
            org: customer.org || '',
            date: payment.date || '',
            doc: payment.voucherNumber || payment.id || '',
            type: outgoing ? t('cust.ledger.refund') : t('cust.ledger.payment'),
            due: '',
            debit: outgoing ? amount : '',
            credit: outgoing ? '' : amount,
            balance,
            paid: '',
            remaining: '',
            status: t('cust.ledger.posted'),
          });
        });
        if (!isCredit) (invoice.customerCreditAllocations || []).forEach((settlement) => {
          const amount = Math.abs(Number(settlement.amount) || 0);
          if (!amount) return;
          entries.push({
            sortDate: settlement.date || invoice._backend?.date || invoice.date || '',
            code: customer.nr || customer.id,
            name: customer.name,
            org: customer.org || '',
            date: settlement.date || '',
            doc: settlement.id || invoice.num || invoice.id,
            type: t('cust.ledger.creditOffset'),
            due: '',
            debit: '',
            credit: amount,
            balance,
            paid: '',
            remaining: '',
            status: t('cust.ledger.posted'),
          });
        });
        if (!isCredit && !(invoice.payments || []).filter((payment) => payment.status !== 'reversed').length && (invoice.status === 'betalt' || invoice.paidAt)) {
          entries.push({
            sortDate: invoice._backend?.paidAt || invoice.paidAt || invoice._backend?.date || invoice.date || '',
            code: customer.nr || customer.id,
            name: customer.name,
            org: customer.org || '',
            date: invoice._backend?.paidAt || invoice.paidAt || invoice._backend?.date || invoice.date || '',
            doc: invoice.num || invoice.id,
            type: t('cust.ledger.payment'),
            due: '',
            debit: '',
            credit: gross,
            paid: '',
            remaining: '',
            status: t('cust.ledger.posted'),
          });
        }
      });
    (customer.importedOpenItems || []).forEach((item) => {
      const remaining = Number(item.remainingAmount || 0);
      if (Math.abs(remaining) <= 0.005) return;
      entries.push({
        sortDate: item.date || item.dueDate || '',
        code: customer.nr || customer.id,
        name: customer.name,
        org: customer.org || '',
        date: item.date || '',
        doc: item.invoiceNumber || item.importItemKey || item.id || '',
        type: remaining < 0 ? t('cust.ledger.creditOverpayment') : t('importOpen.customerInvoice'),
        due: item.dueDate || '',
        debit: remaining > 0 ? remaining : '',
        credit: remaining < 0 ? Math.abs(remaining) : '',
        paid: '',
        remaining,
        status: remaining < 0 ? t('importOpen.credit') : t('importOpen.open'),
      });
    });
    entries
      .sort((a, b) => String(a.sortDate || '').localeCompare(String(b.sortDate || '')))
      .forEach((entry) => {
        balance = Math.round((balance + (Number(entry.debit) || 0) - (Number(entry.credit) || 0)) * 100) / 100;
        rows.push({ ...entry, balance });
      });
  });
  return rows;
};
function ArchiveCustomerModal({ customer, info, onClose, onConfirm }) {
  if (!customer) return null;
  const hasLinks = (info?.groupMembershipCount || 0) > 0 || (info?.subscriptionCount || 0) > 0;
  const groups = info?.groupMembershipCount || 0;
  const subscriptions = info?.subscriptionCount || 0;
  return <Modal open onClose={onClose} title={t('cust.archiveTitle')} max={480}
    footer={<React.Fragment><Button variant="ghost" onClick={onClose}>{t('common.cancel')}</Button><Button variant="danger-solid" onClick={onConfirm} icon="trash" data-help={t('helpTopics.archive.body')} data-help-title={t('helpTopics.archive.title')}>{t('cust.act.archive')}</Button></React.Fragment>}>
    <div className="col gap-12" style={{ paddingBottom: 8 }}>
      <p className="t-body">{splitAround('cust.archiveBody', 'name', <b>{customer.name}</b>)}</p>
      {hasLinks && <div style={{ border: '1px solid var(--warning)', background: 'var(--warning-bg)', borderRadius: 'var(--r-ms)', padding: '10px 12px' }}>
        <b className="t-sm">{t('cust.archiveStillUsed')}</b>
        <div className="t-sm muted" style={{ marginTop: 4 }}>
          {groups > 0 ? t(groups === 1 ? 'cust.archiveGroup' : 'cust.archiveGroups', { n: groups }) : ''}
          {groups > 0 && subscriptions > 0 ? t('cust.archiveAnd') : ''}
          {subscriptions > 0 ? t(subscriptions === 1 ? 'cust.archiveSubscription' : 'cust.archiveSubscriptions', { n: subscriptions }) : ''}.
        </div>
      </div>}
    </div>
  </Modal>;
}
function KunderPage({ setRoute, client = 'joda' }) {
  const store = window.clientStore;
  const importInputRef = useRef(null);
  const customerFallback = () => window.PlummeBackend?.configured ? [] : (typeof CUSTOMERS !== 'undefined' ? CUSTOMERS : []);
  const [rows, setRowsState] = useState(() => store ? store.get(client, 'customers', customerFallback()) : customerFallback());
  const prevClient = useRef(client);
  useEffect(() => { if (prevClient.current !== client) { prevClient.current = client; setRowsState(store ? store.get(client, 'customers', customerFallback()) : customerFallback()); } }, [client]);
  useEffect(() => {
    const h = () => setRowsState(store ? store.get(client, 'customers', customerFallback()) : customerFallback());
    window.addEventListener('plumme-customers-changed', h);
    window.addEventListener('plumme-invoices-changed', h);
    window.addEventListener('plumme-backend-state', h);
    return () => {
      window.removeEventListener('plumme-customers-changed', h);
      window.removeEventListener('plumme-invoices-changed', h);
      window.removeEventListener('plumme-backend-state', h);
    };
  }, [client]);
  useEffect(() => {
    const target = window.PlummeBackend?.openCustomerConversation || null;
    if (!target?.customerId) return;
    const customer = rows.find((entry) => entry.id === target.customerId);
    if (!customer) return;
    window.PlummeBackend.consumeOpenCustomerConversation?.();
    setExp(customer.id);
    setModal({ chat: customer, openThreadId: target.threadId || null });
  }, [rows]);
  const setRows = (updater) => setRowsState((prev) => { const next = typeof updater === 'function' ? updater(prev) : updater; if (store) store.set(client, 'customers', next); return next; });
  const [search, setSearch] = useState('');
  const [exp, setExp] = useState(null);
  const [del, setDel] = useState(null);
  const [archiveInfo, setArchiveInfo] = useState(null);
  const [modal, setModal] = useState(null);
  const [merge, setMerge] = useState(null);
  const [filter, setFilter] = useState(makeFilter());
  const [importMenuOpen, setImportMenuOpen] = useState(false);
  const [exportMenuOpen, setExportMenuOpen] = useState(false); useRegistryPageIntent('customer', (intent) => { if (intent.action === 'search') { setSearch(intent.query || ''); setExp(null); } if (intent.action === 'open_record') { setSearch(rows.find((entry) => entry.id === intent.recordId)?.name || ''); setFilter(makeFilter({ checks: { arkiv: true } })); setExp(intent.recordId || null); } if (intent.action === 'open_merge') { const row=rows.find((entry)=>entry.id===intent.recordId);if(row)setMerge(row); } });
  const stk = ['aktiv', 'prospekt', 'tilbudsendt', 'pause'].filter((k) => filter.checks[k]);
  const filtered = rows.filter((c) => filter.checks.arkiv ? true : !c.arkivert).
  filter((c) => !stk.length || stk.includes(c.crm || 'aktiv')).
  filter((c) => !filter.checks.utestaaende || Math.abs(Number(c.out) || 0) > 0.005).
  filter((c) => window.PlummeListSearch.matches(search, {
    text: [c.name, c.email],
    amounts: [c.out, c.sales],
  }));
  const mergeCustomers = (masterId, duplicateId) => {
    if (!window.PlummeBackend?.mergeCustomers) {
      toast(t('cust.merge.notConnected'), 'error');
      return;
    }
    window.PlummeBackend.mergeCustomers(masterId, duplicateId)
      .then((mergedRows) => {
        if (Array.isArray(mergedRows)) setRowsState(mergedRows);
        setExp(null);
        setMerge(null);
        toast(t('cust.merge.done'), 'success');
      })
      .catch((error) => toast(error?.message || t('cust.merge.failed'), 'error'));
  };
  const saveCustomer = async (data) => {
    const activityText = String(data.activity || '').trim();
    const cleanData = { ...data, activity: undefined };
    const nextCustomer = modal.customer
      ? {
          ...modal.customer,
          ...cleanData,
          activities: activityText
            ? [{ date: new Date().toISOString().slice(0, 10), text: activityText }, ...(modal.customer.activities || [])]
            : (modal.customer.activities || []),
        }
      : {
          ...cleanData,
          id: 'c' + Date.now(),
          nr: data.nr || String(rows.length + 1).padStart(4, '0'),
          out: 0,
          sales: 0,
          status: 'aktiv',
          activities: activityText ? [{ date: new Date().toISOString().slice(0, 10), text: activityText }] : [],
        };
    if (window.PlummeBackend?.saveCustomerRecord) {
      try {
        const saved = await window.PlummeBackend.saveCustomerRecord(nextCustomer);
        if (saved) setRowsState((r) => [saved, ...r.filter((x) => x.id !== saved.id)]);
        toast(t(modal.customer ? 'cust.toast.updated' : 'cust.toast.saved'), 'success');
        setModal(null);
        return;
      } catch (error) {
        toast(error?.message || t('cust.toast.saveFailed'), 'error');
        return;
      }
    }
    if (modal.customer) {
      setRows((r) => r.map((x) => {
        if (x.id !== modal.customer.id) return x;
        return nextCustomer;
      }));
      toast(t('cust.toast.updated'), 'success');
    } else {
      setRows((r) => [nextCustomer, ...r]);
      toast(t('cust.toast.saved'), 'success');
    }
    setModal(null);
  };
  const applyUpdatedCustomer = (updatedCustomer) => {
    if (!updatedCustomer?.id) return;
    setRowsState((r) => r.map((x) => x.id === updatedCustomer.id ? updatedCustomer : x));
    setModal((current) => {
      if (current?.chat?.id === updatedCustomer.id) return { ...current, chat: updatedCustomer };
      if (current?.customer?.id === updatedCustomer.id) return { ...current, customer: updatedCustomer };
      return current;
    });
  };
  const openArchive = (customer) => {
    setArchiveInfo(window.PlummeBackend?.getCustomerArchiveInfo?.(customer.id) || null);
    setDel(customer);
  };
  const archiveCustomer = async () => {
    if (!del) return;
    if (window.PlummeBackend?.archiveCustomerRecord) {
      try {
        const archived = await window.PlummeBackend.archiveCustomerRecord(del.id);
        if (archived) setRowsState((r) => r.map((x) => x.id === archived.id ? archived : x));
        setExp(null);
        setDel(null);
        setArchiveInfo(null);
        toast(t('cust.toast.archived'), 'success');
      } catch (error) {
        toast(error?.message || t('cust.toast.archiveFailed'), 'error');
      }
      return;
    }
    setRows((r) => r.map((x) => x.id === del.id ? { ...x, arkivert: true } : x));
    setExp(null);
    setDel(null);
    setArchiveInfo(null);
    toast(t('cust.toast.archived'), 'success');
  };
  const exportCustomers = async (kind) => {
    if (!filtered.length) { toast(t('cust.toast.nothingToExport'), 'info'); return; }
    const columns = customerExportColumns();
    try {
      if (kind === 'xlsx') await exportRowsXlsx('plumme-kunder', columns, filtered, t('cust.sheet.customers'));
      else window.exportTable('plumme-kunder', columns, filtered, kind);
    } catch (error) {
      toast(error?.message || t('cust.toast.exportFailed'), 'error');
      return;
    }
    toast(t('cust.toast.exported'), 'success');
  };
  const exportCustomerLedger = async (kind) => {
    const ledgerRows = buildCustomerLedgerRows(filtered);
    if (!ledgerRows.length) { toast(t('cust.toast.noLedgerRows'), 'info'); return; }
    const filename = 'kunder-reskontro-' + new Date().getFullYear();
    const columns = customerLedgerColumns();
    try {
      if (kind === 'xlsx') await exportRowsXlsx(filename, columns, ledgerRows, t('cust.ledger.sheet'));
      else window.exportTable(filename, columns, ledgerRows, kind);
    } catch (error) {
      toast(error?.message || t('cust.toast.ledgerExportFailed'), 'error');
      return;
    }
    toast(t('cust.toast.ledgerExported'), 'success');
  };
  const importCustomersFromFile = async (event) => {
    const file = event.target.files?.[0];
    event.target.value = '';
    if (!file) return;
    if (!/\.(csv|xlsx)$/i.test(file.name)) {
      toast(t('cust.toast.wrongFormat'), 'error');
      return;
    }
    try {
      const imported = /\.xlsx$/i.test(file.name) ? await parseCustomerXlsx(file) : parseCustomerCsv(await file.text());
      if (!imported.length) throw new Error(t('cust.toast.noneInFile'));
      const nextRows = window.PlummeBackend?.importCustomerRecords
        ? await window.PlummeBackend.importCustomerRecords(imported)
        : [...imported.map((customer, index) => ({ ...customer, id: customer.id || 'c' + Date.now() + '-' + index, out: 0, sales: 0, status: 'aktiv' })), ...rows];
      if (Array.isArray(nextRows)) setRowsState(nextRows);
      toast(t('cust.toast.imported', { n: imported.length }), 'success');
    } catch (error) {
      toast(error?.message || t('cust.toast.importFailed'), 'error');
    }
  };
  const openImportPicker = (kind) => {
    const input = importInputRef.current;
    if (!input) return;
    input.accept = kind === 'xlsx'
      ? '.xlsx,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
      : '.csv,text/csv';
    setImportMenuOpen(false);
    input.click();
  };
  const customerHeaderTools = <div className="customer-header-tools">
    <div className="popwrap">
      <button type="button" className="customer-transfer-trigger" aria-label={t('cust.import')} title={t('cust.import')} onClick={() => { setImportMenuOpen((open) => !open); setExportMenuOpen(false); }}>
        <Icon name="upload" size={18} /><Icon name="chevDown" size={18} />
      </button>
      {importMenuOpen && <React.Fragment><div className="pop-scrim" onClick={() => setImportMenuOpen(false)} />
        <div className="pop customer-transfer-menu customer-transfer-menu-import">
          <button onClick={() => openImportPicker('csv')}><Icon name="fileText" size={20} /><span>{t('cust.importFrom')}<br />{t('set.csv')}</span></button>
          <button onClick={() => openImportPicker('xlsx')}><Icon name="files" size={20} /><span>{t('cust.importFrom')}<br />{t('prd.excel')}</span></button>
        </div></React.Fragment>}
    </div>
    <div className="popwrap">
      <button type="button" className="customer-transfer-trigger" aria-label={t('list.export')} title={t('list.export')} onClick={() => { setExportMenuOpen((open) => !open); setImportMenuOpen(false); }}>
        <Icon name="download" size={18} /><Icon name="chevDown" size={18} />
      </button>
      {exportMenuOpen && <React.Fragment><div className="pop-scrim" onClick={() => setExportMenuOpen(false)} />
        <div className="pop customer-transfer-menu customer-transfer-menu-export">
          <div className="customer-transfer-section">{t('cust.title')}</div>
          <button onClick={() => { setExportMenuOpen(false); exportCustomers('csv'); }}><Icon name="fileText" size={20} /><span>{t('cust.title')} CSV</span></button>
          <button onClick={() => { setExportMenuOpen(false); exportCustomers('xlsx'); }}><Icon name="files" size={20} /><span>{t('cust.title')} Excel</span></button>
          <div className="customer-transfer-sep" />
          <div className="customer-transfer-section">{t('cust.ledgerShort')}</div>
          <button onClick={() => { setExportMenuOpen(false); exportCustomerLedger('csv'); }}><Icon name="fileText" size={20} /><span>{t('cust.ledgerShort')} CSV</span></button>
          <button onClick={() => { setExportMenuOpen(false); exportCustomerLedger('xlsx'); }}><Icon name="files" size={20} /><span>{t('cust.ledgerShort')}<br />{t('rep.excel')}</span></button>
        </div></React.Fragment>}
    </div>
  </div>;
  const filterEl = <FilterPanel value={filter} onChange={setFilter} onReset={() => setFilter(makeFilter())} help={t('cust.filterHelp')} groups={[{ label: t('cust.status'), options: [{ key: 'aktiv', label: t('crm.active') }, { key: 'prospekt', label: t('crm.prospect') }, { key: 'tilbudsendt', label: t('crm.quoteSent') }, { key: 'pause', label: t('crm.pause') }] }, { label: t('cust.filterOther'), options: [{ key: 'utestaaende', label: t('cust.filterWithOutstanding') }, { key: 'arkiv', label: t('cust.filterShowArchive') }] }]} />;
  return <div>
    <ListShell title={t('cust.title')} subtitle={t('cust.subtitle')} searchPh={t('cust.searchPh')} noHeaderSearch
    titleHelp={t('cust.titleHelp')} searchHelp={t('cust.searchHelp')} uploadHelp={t('cust.uploadHelp')} downloadHelp={t('cust.downloadHelp')} addHelp={t('cust.addHelp')}
    search={search} setSearch={setSearch} onAdd={() => setModal({ customer: null })} addLabel={t('sale.cust.new')}
    tools={false}
    headerTools={customerHeaderTools}>
      <input ref={importInputRef} type="file" accept=".csv,.xlsx,text/csv,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" style={{ display: 'none' }} onChange={importCustomersFromFile} />
      {/* Søk + filter i egen verktøyrad over lista, ikke i sidehodet */}
      <div className="fak-list-tools">
        <SearchField value={search} onChange={setSearch} placeholder={t('cust.searchPh')} help={t('cust.searchHelp')} />
        {filterEl}
      </div>
      <div data-help-title={t('cust.listHelpTitle')} data-help={t('cust.listHelp')}>
      <DataList rows={filtered} rowKey={(c) => c.id} tableClass="kdr-tbl"
        onRowClick={(c) => setExp(exp === c.id ? null : c.id)}
        expandedKey={exp} renderExpanded={(c) => <CustomerDetail c={c} setRoute={setRoute} onDelete={() => openArchive(c)} onEdit={() => setModal({ customer: c })} onChat={() => setModal({ chat: c })} onMerge={() => setMerge(c)} />}
        columns={[
          { header: t('cust.col.customer'), render: (c) => <React.Fragment><div className="t-h3" style={{ fontSize: 14.5 }}>{c.name}</div><div className="row gap-8" style={{ marginTop: 4, flexWrap: 'wrap' }}>{c.arkivert ? <span className="crm-badge crm-pause">{t('cust.archived')}</span> : crmBadge(c)}{c.followUp && !c.arkivert && <span className="t-xs muted">{t('cust.followUpInline', { date: customerDate(c.followUp) })}</span>}<span className="t-xs muted">{c.addr}</span></div><div className="kdr-contact-inline t-xs muted">{c.org && c.org !== '—' && <span className="kdr-orgnr"><b>{t('cust.col.org')}</b> {c.org}</span>}{c.email && <span><Icon name="mail" size={12} />{c.email}</span>}{c.phone && <span><Icon name="phone" size={12} />{c.phone}</span>}</div></React.Fragment> },
          { header: t('cust.col.number'), thClass: 'kdr-nr-col', cellClass: 't-sm muted kdr-nr-col', render: (c) => c.nr },
          { header: t('cust.col.org'), thClass: 'kdr-org-col', cellClass: 't-sm muted kdr-org-col', render: (c) => c.org },
          { header: t('cust.col.email'), thClass: 'kdr-email-col', cellClass: 't-sm muted kdr-email-col', render: (c) => <CopyText text={c.email} /> },
          { header: t('cust.col.phone'), thClass: 'kdr-phone-col', cellClass: 't-sm muted kdr-phone-col', render: (c) => c.phone },
          { header: t('cust.col.outstanding'), headerRight: true, thClass: 'kdr-out-col', cellClass: 'num kdr-out-col', tdStyle: (c) => ({ color: customerNetBalanceMeta(c.out).tone }), render: (c) => fmt(c.out) },
          { header: t('cust.col.totalSales'), headerRight: true, cellClass: 'num', render: (c) => { const meta = customerNetBalanceMeta(c.out); return <React.Fragment>{fmt(c.sales)}<div className="kdr-out-sub" style={{ color: meta.tone }}>{meta.text}</div></React.Fragment>; } },
        ]} />
      </div>
    </ListShell>
    <ArchiveCustomerModal customer={del} info={archiveInfo} onClose={() => { setDel(null); setArchiveInfo(null); }} onConfirm={archiveCustomer} />
    {modal && !modal.chat && <CustomerModal customer={modal.customer} existing={rows} onClose={() => setModal(null)} onSave={saveCustomer} />}
    {modal && modal.chat && <CustomerChatModal customer={modal.chat} openThreadId={modal.openThreadId} onClose={() => setModal(null)} setRoute={setRoute} onCustomerUpdated={applyUpdatedCustomer} />}
    {merge && <MergeRecordModal kind="kunde" primary={merge} candidates={rows.filter((x) => x.id !== merge.id && !x.arkivert)}
      onClose={() => setMerge(null)}
      onMerge={mergeCustomers} />}
  </div>;
}
// Verdiene er stabile id-er; etiketten slås opp ved render.
const CRM_OPTS = ['prospekt', 'tilbudsendt', 'aktiv', 'pause'];
const crmOptionLabel = (value) => t(PlummeI18n.keyFor('cust.crm', value, 'crm'));
const CRM_TINT = { prospekt: 'var(--muted-2)', tilbudsendt: 'var(--warning)', aktiv: 'var(--success)', pause: 'var(--plum-400)' };
function MergeCustomerCard({ record, role }) {
  return <div style={{ border: '1px solid ' + (role === 'primary' ? 'var(--plum-300)' : 'var(--border)'), borderRadius: 'var(--r-md)', padding: '12px 14px', background: role === 'primary' ? 'var(--plum-50)' : 'var(--card)', minWidth: 0 }}>
    <div className="t-xs muted" style={{ fontWeight: 800, textTransform: 'uppercase', letterSpacing: '.04em', marginBottom: 6 }}>{role === 'primary' ? t('cust.merge.keep') : t('cust.merge.remove')}</div>
    <div className="t-h3" style={{ fontSize: 15, marginBottom: 8 }}>{record.name}</div>
    <div className="col gap-6">
      {record.org ? <div className="row between gap-10"><span className="t-xs muted">{t('cust.col.org')}</span><b className="t-xs">{record.org}</b></div> : null}
      {record.email ? <div className="row between gap-10"><span className="t-xs muted">{t('cust.col.email')}</span><b className="t-xs" style={{ overflow: 'hidden', textOverflow: 'ellipsis' }}>{record.email}</b></div> : null}
      <div className="row between gap-10"><span className="t-xs muted" data-help={t('helpTopics.openItem.body')} data-help-title={t('helpTopics.openItem.title')}>{t('cust.col.outstanding')}</span><b className="t-xs t-num">{fmt(record.out || 0)}</b></div>
    </div>
  </div>;
}
function MergeRecordModal({ kind, primary, candidates, onClose, onMerge }) {
  const [duplicateId, setDuplicateId] = useState('');
  const [keepDuplicate, setKeepDuplicate] = useState(false);
  const duplicate = candidates.find((c) => c.id === duplicateId) || null;
  const master = keepDuplicate ? (duplicate || primary) : primary;
  const other = keepDuplicate ? primary : duplicate;
  const combinedOut = (primary.out || 0) + (duplicate ? (duplicate.out || 0) : 0);
  const combinedSales = (primary.sales || 0) + (duplicate ? (duplicate.sales || 0) : 0);
  return <Modal open center onClose={onClose} title={t('cust.merge.title')} max={620}
    footer={<React.Fragment>
      <Button variant="ghost" onClick={onClose}>{t('common.cancel')}</Button>
      <Button icon="swap" disabled={!duplicate} onClick={() => duplicate && onMerge(master.id, other.id)} data-help={t('helpTopics.customerMerge.body')} data-help-title={t('helpTopics.customerMerge.title')}>{t('cust.merge.title')}</Button>
    </React.Fragment>}>
    <div className="col gap-14" style={{ paddingBottom: 4 }}>
      <div style={{ background: 'var(--plum-50)', border: '1px solid var(--plum-200)', borderRadius: 'var(--r-md)', padding: '13px 15px' }}>
        <b>{t('cus.merge.headline')}</b>
        <div className="t-sm" style={{ fontWeight: 600, color: 'var(--ink-2)', marginTop: 3 }}>{t('cus.merge.help')}</div>
      </div>
      <Field label={t('cus.merge.whichSame', { name: primary.name })}>
        <Select value={duplicateId} onChange={(e) => { setDuplicateId(e.target.value); setKeepDuplicate(false); }}>
          <option value="">{t('cus.merge.selectCustomer')}</option>
          {candidates.map((c) => <option key={c.id} value={c.id}>{c.name}{c.org ? ' · ' + c.org : ''}</option>)}
        </Select>
      </Field>
      {duplicate && <React.Fragment>
        <div style={{ display: 'grid', gridTemplateColumns: '1fr auto 1fr', gap: 10, alignItems: 'center' }}>
          <MergeCustomerCard record={master} role="primary" />
          <IconButton name="swap" variant="secondary" title={t('cust.merge.swap')} onClick={() => setKeepDuplicate((v) => !v)} />
          <MergeCustomerCard record={other} role="duplicate" />
        </div>
        <div style={{ border: '1px solid var(--border)', borderRadius: 'var(--r-md)', padding: '12px 14px', background: 'var(--card)' }}>
          <div className="t-xs muted" style={{ fontWeight: 800, textTransform: 'uppercase', letterSpacing: '.04em', marginBottom: 8 }}>{t('cust.merge.after')}</div>
          <div className="row between gap-10"><span className="t-sm muted">{t('cust.merge.name')}</span><b>{master.name}</b></div>
          <div className="row between gap-10"><span className="t-sm muted">{t('cust.merge.totalSales')}</span><b className="t-num">{fmt(combinedSales)}</b></div>
          <div className="row between gap-10"><span className="t-sm muted" data-help={t('helpTopics.openItem.body')} data-help-title={t('helpTopics.openItem.title')}>{t('cust.col.outstanding')}</span><b className="t-num">{fmt(combinedOut)}</b></div>
        </div>
      </React.Fragment>}
    </div>
  </Modal>;
}
const normalizeAddressSuggestion = (entry) => {
  const houseNo = [entry.nummer, entry.bokstav].filter(Boolean).join('');
  const address = entry.adressetekst || [entry.adressenavn, houseNo].filter(Boolean).join(' ');
  return {
    id: entry.id || [address, entry.postnummer, entry.poststed].filter(Boolean).join('-'),
    address,
    zip: entry.postnummer || '',
    city: entry.poststed || '',
  };
};

function AddressLookupField({ f, set }) {
  const [suggestions, setSuggestions] = useState([]);
  const [loading, setLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const query = (f.addr || '').trim();
  useEffect(() => {
    if (query.length < 3) { setSuggestions([]); setLoading(false); return undefined; }
    const ctrl = new AbortController();
    const timer = setTimeout(async () => {
      setLoading(true);
      try {
        const url = 'https://ws.geonorge.no/adresser/v1/sok?sok=' + encodeURIComponent(query) + '&treffPerSide=8';
        const response = await fetch(url, { signal: ctrl.signal, headers: { Accept: 'application/json' } });
        if (!response.ok) throw new Error('Address lookup failed');
        const payload = await response.json();
        setSuggestions((payload.adresser || []).map(normalizeAddressSuggestion).filter((a) => a.address));
        setOpen(true);
      } catch (error) {
        if (error.name !== 'AbortError') setSuggestions([]);
      } finally {
        if (!ctrl.signal.aborted) setLoading(false);
      }
    }, 250);
    return () => { clearTimeout(timer); ctrl.abort(); };
  }, [query]);
  const choose = (item) => {
    set({ addr: item.address, zip: item.zip, city: item.city });
    setOpen(false);
  };
  return <div className="popwrap">
    <Field label={t('cust.form.address')}><Input value={f.addr} onChange={(e) => { set({ addr: e.target.value }); setOpen(true); }} onFocus={() => query.length >= 3 && setOpen(true)} placeholder={t('cust.form.addressPh')} /></Field>
    {open && (loading || suggestions.length > 0) && <React.Fragment>
      <div className="pop-scrim" onClick={() => setOpen(false)} />
      <div className="pop pop-menu" style={{ top: 'calc(100% + 6px)', left: 0, right: 0, maxHeight: 260, overflow: 'auto' }}>
        {loading && <div className="t-sm muted" style={{ padding: '10px 12px', fontWeight: 700 }}>{t('cus.address.searching')}</div>}
        {suggestions.map((item) => <button key={item.id} type="button" onClick={() => choose(item)}>
          <Icon name="mapPin" size={16} />
          <span style={{ minWidth: 0, textAlign: 'left' }}><b>{item.address}</b><span className="t-xs muted" style={{ display: 'block' }}>{[item.zip, item.city].filter(Boolean).join(' ')}</span></span>
        </button>)}
      </div>
    </React.Fragment>}
  </div>;
}

// Advarselen om at opplysningen finnes fra for.
//
// Plumme slaar ikke sammen kunder av seg selv. To selskaper kan dele adresse,
// e-postadresse og navn — likhet er ikke bevis paa at det er den samme kunden,
// og en automatisk sammenslaaing tar en avgjorelse foretaket selv maa ta. Det
// gjores i sammenslaaingen i kunderegisteret, og bare der.
//
// Men den som er i ferd med aa opprette den samme kunden for andre gang skal
// vite det mens skjemaet staar aapent, ikke oppdage det i fakturalisten senere.
// Derfor sier skjemaet fra — og lagrer likevel.
const customerDupText = (value) => String(value || '').trim().toLocaleLowerCase('nb-NO').replace(/\s+/g, ' ');
const customerDupDigits = (value) => String(value || '').replace(/\D/g, '');
// Feltet sammenlignes forst naar det er skrevet ferdig. Ellers ville «No» lyst
// rodt mot «Nordvik AS» etter to tastetrykk, og advarselen blitt stoy brukeren
// slutter aa lese.
const CUSTOMER_DUPLICATE_FIELDS = [
  { key: 'name', labelKey: 'cust.form.dupName', value: (row) => customerDupText(row.name), ready: (value) => value.length >= 3 },
  { key: 'org', labelKey: 'cust.form.dupOrg', value: (row) => customerDupDigits(row.org), ready: (value) => value.length === 9 },
  { key: 'email', labelKey: 'cust.form.dupEmail', value: (row) => customerDupText(row.email), ready: (value) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value) },
  { key: 'phone', labelKey: 'cust.form.dupPhone', value: (row) => customerDupDigits(row.phone), ready: (value) => value.length >= 8 },
];
const customerDuplicateWarnings = (form, existing, currentId) => {
  const others = (Array.isArray(existing) ? existing : []).filter((row) => row && row.id !== currentId);
  if (!others.length) return [];
  return CUSTOMER_DUPLICATE_FIELDS.map((field) => {
    const value = field.value(form);
    if (!field.ready(value)) return null;
    // Samme kunde to ganger i lista skal ikke navngis to ganger.
    const names = [...new Set(others.filter((row) => field.value(row) === value).map((row) => row.name || t('cust.form.dupUnnamed')))];
    return names.length ? { key: field.key, text: t(field.labelKey, { names: names.join(', ') }) } : null;
  }).filter(Boolean);
};

function CustomerModal({ customer, initial, existing = [], onClose, onSave, busy = false, error = '', portal = false, autoSave = false }) {
  const edit = !!customer;const c = customer || initial || {};
  const [f, setF] = useState(() => ({ name: c.name || '', org: c.org || '', email: c.email || '', phone: c.phone || '', addr: c.addr || '', zip: c.zip || '', city: c.city || '', crm: c.crm || 'aktiv', followUp: c.followUp || '', defaultCustomerReference: c.defaultCustomerReference || '', creditLimit: c.creditLimit === 0 || c.creditLimit ? String(c.creditLimit) : '', note: c.note || '', activity: '', contactPersons: (c.contactPersons || []).map((contact, index) => ({ id: contact.id || 'contact-' + index, name: contact.name || contact.navn || '', role: contact.role || contact.rolle || '', email: contact.email || contact.epost || '', phone: contact.phone || contact.telefon || '' })) }));
  const set = (p) => setF((s) => ({ ...s, ...p }));
  // Kontaktpersonene vises som én plukker med blyantknapp, og redigeres i en egen
  // dialog. `pendingContact` er en kontakt «Legg til» nettopp opprettet: avbryter
  // brukeren dialogen, skal den ikke bli liggende igjen som en tom rad i plukkeren.
  const [registryOn, setRegistryOn] = useBusinessRegistryToggle();
  const [selectedContact, setSelectedContact] = useState(null);
  const [editContact, setEditContact] = useState(null);
  const [pendingContact, setPendingContact] = useState(null);
  const contacts = f.contactPersons || [];
  const activeContact = contacts.find((contact) => contact.id === selectedContact) || contacts[0] || null;
  const contactLabel = (contact, index) => (contact.name || t('cust.form.contactFallback', { n: index + 1 })) + (contact.role ? ' · ' + contact.role : '');
  const updateContact = (id, patch) => setF((current) => ({ ...current, contactPersons: (current.contactPersons || []).map((contact) => contact.id === id ? { ...contact, ...patch } : contact) }));
  const removeContact = (id) => {
    setF((current) => ({ ...current, contactPersons: (current.contactPersons || []).filter((contact) => contact.id !== id) }));
    setSelectedContact((current) => current === id ? null : current);
  };
  const addContact = () => {
    const id = 'contact-' + Date.now();
    setF((current) => ({ ...current, contactPersons: [...(current.contactPersons || []), { id, name: '', role: '', email: '', phone: '' }] }));
    setSelectedContact(id);
    setPendingContact(id);
    setEditContact(id);
  };
  const closeContactModal = () => {
    if (pendingContact) removeContact(pendingContact);
    setPendingContact(null);
    setEditContact(null);
  };
  const saveContact = (patch) => { updateContact(editContact, patch); setPendingContact(null); setEditContact(null); };
  const deleteContact = () => { removeContact(editContact); setPendingContact(null); setEditContact(null); };
  const savePayload = () => ({
    ...f,
    contactPersons: (f.contactPersons || []).map((contact) => ({ id: contact.id, name: contact.name || '', role: contact.role || '', email: contact.email || '', phone: contact.phone || '' })).filter((contact) => contact.name || contact.email || contact.phone),
  }); usePageOwnedAutoSubmit(autoSave, () => onSave?.(savePayload()));
  const duplicateWarnings = customerDuplicateWarnings(f, existing, c.id);
  const crmLabel = crmOptionLabel(CRM_OPTS.includes(f.crm) ? f.crm : 'aktiv');
  // Escape er registrert pa window i begge dialogene. Uten denne sperren ville ett
  // tastetrykk i kontaktdialogen ogsa lukket hele kundekortet og forkastet skjemaet.
  return <Modal open portal={portal} onClose={() => { if (!editContact) onClose(); }} title={edit ? t('cust.form.editTitle') : t('cust.form.newTitle')} max={620}
    footer={<React.Fragment><Button variant="ghost" disabled={busy} onClick={onClose}>{t('common.cancel')}</Button><Button disabled={busy} onClick={() => onSave && onSave(savePayload())} icon="check">{t(edit ? 'cust.form.update' : 'cust.form.save')}</Button></React.Fragment>}>
    <div className="col gap-14" style={{ paddingBottom: 4 }}>{error && <p role="alert" className="invoice-control-error">{error}</p>}
      <div className="grid-2 gap-14">
        {/* Registersoket er valgfritt: privatkunder slaar det av og skriver bare navnet. */}
        <div style={{ gridColumn: '1 / -1' }}><BusinessRegistryToggle on={registryOn} onChange={setRegistryOn} /></div>
        <Field label={t('cust.form.name')}><Input value={f.name} onChange={(e) => set({ name: e.target.value })} placeholder={t('cust.form.namePh')} /></Field>
        <Field label={t('cust.form.orgOptional')}><Input value={f.org} onChange={(e) => set({ org: e.target.value })} placeholder={t('sale.cust.orgPh')} /></Field>
        {registryOn && <div style={{ display: 'contents' }}>
          <BusinessRegistryLookup quiet query={f.org || f.name}
            onApply={(match) => setF((current) => window.PlummeBusinessRegistry.applyToCustomerDraft(match, current))} />
        </div>}
        <Field label={t('cust.col.email')}><Input value={f.email} onChange={(e) => set({ email: e.target.value })} placeholder={t('sale.cust.emailPh')} /></Field>
        <Field label={t('cust.col.phone')}><Input value={f.phone} onChange={(e) => set({ phone: e.target.value })} placeholder={t('sale.cust.phonePh')} /></Field>
        <AddressLookupField f={f} set={set} />
        <Field label={t('cust.form.zip')}><Input value={f.zip} onChange={(e) => set({ zip: e.target.value })} placeholder="0000" /></Field>
        <Field label={t('cust.form.city')}><Input value={f.city} onChange={(e) => set({ city: e.target.value })} placeholder={t('cust.form.cityPh')} /></Field>
      </div>
      {duplicateWarnings.length > 0 && <div className="alert alert-warning" style={{ alignItems: 'flex-start' }}>
        <span className="alert-ico"><Icon name="alertTri" size={17} /></span>
        <div>
          <b>{t('cust.form.dupTitle')}</b>
          <ul className="cust-dup-list">{duplicateWarnings.map((warning) => <li key={warning.key}>{warning.text}</li>)}</ul>
          <div className="t-sm" style={{ fontWeight: 600, marginTop: 6 }}>{t('cust.form.dupBody')}</div>
        </div>
      </div>}
      <div className="col gap-10" style={{ paddingTop: 2 }}>
        <div className="row between gap-12" style={{ alignItems: 'center' }}>
          <b className="t-h3" style={{ fontSize: 15 }}>{t('cust.form.contacts')}</b>
          <Button size="sm" variant="secondary" icon="plus" onClick={addContact}>{t('cust.form.addContact')}</Button>
        </div>
        <span className="t-sm muted" style={{ fontWeight: 600 }}>{t('cust.form.contactsSub')}</span>
        {!activeContact
          ? <span className="t-sm muted" style={{ fontWeight: 600, fontStyle: 'italic' }}>{t('sale.cust.noContacts')}</span>
          : <div className="row gap-10">
            <div className="grow" style={{ minWidth: 0 }}><Select value={activeContact.id} onChange={(event) => setSelectedContact(event.target.value)}>
              {contacts.map((contact, index) => <option key={contact.id} value={contact.id}>{contactLabel(contact, index)}</option>)}
            </Select></div>
            <IconButton name="pencil" onClick={() => setEditContact(activeContact.id)} title={t('cust.form.editContact')} aria-label={t('cust.form.editContact')} />
          </div>}
      </div>
      <div className="row gap-12" style={{ alignItems: 'center', paddingTop: 2 }}>
        <span style={{ width: 26, height: 26, borderRadius: '50%', background: CRM_TINT[f.crm], flex: 'none' }} />
        <b className="t-h3" style={{ fontSize: 15 }}>{t('cust.followUp')}</b>
        <span className="t-sm muted" style={{ fontWeight: 700 }}>{f.followUp ? t('cust.form.nextLabel', { date: customerDate(f.followUp) }) : t('cust.form.noFollowUp')}</span>
      </div>
      <div className="grid-2 gap-14">
        <Field label={t('cust.form.crm')}><Select value={f.crm} onChange={(e) => set({ crm: e.target.value })}>{CRM_OPTS.map((v) => <option key={v} value={v}>{crmOptionLabel(v)}</option>)}</Select></Field>
        <Field label={t('cust.nextFollowUp')}><Input type="date" value={f.followUp} onChange={(e) => set({ followUp: e.target.value })} /></Field>
      </div>
      <Field label={t('cust.form.defaultRef')}><Input value={f.defaultCustomerReference} onChange={(e) => set({ defaultCustomerReference: e.target.value })} placeholder={t('cust.form.defaultRefPh')} /></Field><Field label={t('cust.form.creditLimit')} hint={t('cust.form.creditLimitHint')}><Input type="number" min="0" step="1" value={f.creditLimit} onChange={(e) => set({ creditLimit: e.target.value })} placeholder={t('cust.form.creditLimitPh')} /></Field>
      <Field label={t('cust.form.note')}><textarea className="input" rows="3" value={f.note} onChange={(e) => set({ note: e.target.value })} placeholder={t('cust.form.notePh')} /></Field>
      <Field label={t('cust.form.activity')}><textarea className="input" rows="2" value={f.activity} onChange={(e) => set({ activity: e.target.value })} placeholder={t('cust.form.activityPh')} /></Field>
    </div>
    {editContact && <CustomerContactModal contact={contacts.find((contact) => contact.id === editContact) || {}}
      onClose={closeContactModal} onSave={saveContact} onDelete={deleteContact} />}
  </Modal>;
}

// Redigering av én kontaktperson. Feltene holdes lokalt og skrives tilbake til
// kundeskjemaet forst ved «Lagre», slik at «Avbryt» faktisk forkaster endringen.
function CustomerContactModal({ contact, onClose, onSave, onDelete }) {
  const [f, setF] = useState({ name: contact.name || '', role: contact.role || '', email: contact.email || '', phone: contact.phone || '' });
  const set = (p) => setF((s) => ({ ...s, ...p }));
  return <Modal open portal max={480} onClose={onClose} title={t('cust.form.contactTitle')}
    footer={<div className="row between cust-contact-footer" style={{ width: '100%' }}>
      <Button variant="ghost" className="cust-contact-remove" onClick={onDelete}>{t('cust.form.removeContact')}</Button>
      <div className="row gap-10 cust-contact-actions">
        <Button variant="secondary" onClick={onClose}>{t('common.cancel')}</Button>
        <Button icon="check" onClick={() => onSave(f)}>{t('cust.form.saveContact')}</Button>
      </div>
    </div>}>
    <div className="grid-2 gap-14">
      <Field label={t('cust.form.contactName')}><Input value={f.name} onChange={(e) => set({ name: e.target.value })} placeholder={t('cust.form.contactNamePh')} /></Field>
      <Field label={t('cust.form.contactRole')} help={t('helpTopics.contactRole.body')} helpTitle={t('helpTopics.contactRole.title')}><Input value={f.role} onChange={(e) => set({ role: e.target.value })} placeholder={t('cust.form.contactRolePh')} /></Field>
      <Field label={t('cust.col.email')}><Input type="email" value={f.email} onChange={(e) => set({ email: e.target.value })} placeholder={t('sale.cust.emailPh')} /></Field>
      <Field label={t('cust.col.phone')}><Input value={f.phone} onChange={(e) => set({ phone: e.target.value })} placeholder={t('sale.cust.phonePh')} /></Field>
    </div>
  </Modal>;
}

function CustomerChatModal({ customer, openThreadId, onClose, setRoute, onCustomerUpdated }) {
  const c = customer;
  const today = new Date().toLocaleDateString(PlummeI18n.intlLocale());
  // Dialogene ligger ikke lenger i kundeobjektet, men i en egen subcollection, slik at
  // en melding ikke skriver hele app-state. De lastes derfor når modalen åpnes.
  const [loadedThreads, setLoadedThreads] = useState(() => (c.conversationThreads || []));
  const [threadsLoading, setThreadsLoading] = useState(false);
  useEffect(() => {
    if (!window.PlummeBackend?.loadCustomerConversationThreads || !c?.id) return undefined;
    let alive = true;
    setThreadsLoading(true);
    window.PlummeBackend.loadCustomerConversationThreads(c.id)
      .then((next) => { if (alive) setLoadedThreads(next || []); })
      .catch(() => { if (alive) toast(t('cus.chat.loadFailed'), 'error'); })
      .finally(() => { if (alive) setThreadsLoading(false); });
    return () => { alive = false; };
  }, [c?.id]);
  const threads = loadedThreads.slice().sort((a, b) => String(b.updatedAt || '').localeCompare(String(a.updatedAt || '')));
  const [activeId, setActiveId] = useState(openThreadId || threads[0]?.id || null);
  const [dlgOpen, setDlgOpen] = useState(false);
  const [draft, setDraft] = useState('');
  // `scope` holder en stabil id, ikke visningsteksten — ellers ville filtreringen
  // sluttet å virke i det etikettene ble oversatt.
  const SCOPES = ['all', 'to', 'from', 'internal'];
  const scopeLabel = (value) => t('cust.chat.scope.' + value);
  const [scope, setScope] = useState('all');
  const [q, setQ] = useState('');
  const [busy, setBusy] = useState('');
  const messageTextareaRef = useRef(null);
  const active = threads.find((d) => d.id === activeId) || threads[0] || null;
  const msgs = active ? (active.messages || []) : [];
  const lines = active ? (active.quoteLines || []) : [];
  // Kundechatten er en produksjonsflate. Mens et foretak byttes eller state lastes,
  // skal produktlisten vaere tom — aldri falle tilbake til design-fixturen i data.jsx.
  const activeBusinessProducts = window.PlummeBackend?.appState?.products;
  const productSource = Array.isArray(activeBusinessProducts)
    ? activeBusinessProducts.map((product) => ({
      id: product.id,
      name: product.name || '',
      desc: product.description || product.desc || '',
      nr: product.itemNumber || product.nr || product.productNumber || '',
      price: Number(product.unitPrice ?? product.price) || 0,
      vat: product.vatRate ?? product.vat ?? 25,
      vatTreatment: product.vatTreatment || ((Number(product.vatRate ?? product.vat) || 0) === 0 ? 'zeroRated' : 'standard'),
      salesAccountCode: product.salesAccountCode || '3000',
      type: product.kind === 'physical' ? 'Vare' : product.kind === 'subscription' ? 'Abonnement' : product.kind === 'rental' ? 'Utleie' : product.type,
    }))
    : [];
  const prods = productSource.filter((p) => q && (p.name || '').toLowerCase().includes(q.toLowerCase())).slice(0, 6);
  useEffect(() => {
    if (!activeId && threads[0]?.id) setActiveId(threads[0].id);
  }, [activeId, threads[0]?.id]);
  useEffect(() => {
    if (openThreadId && threads.some((thread) => thread.id === openThreadId)) setActiveId(openThreadId);
  }, [openThreadId, threads.map((thread) => thread.id).join('|')]);
  const messageLabel = (direction) => direction === 'inbound' ? t('cust.chat.scope.from') : direction === 'internal' ? t('cust.chat.internal') : t('cust.chat.scope.to');
  const messageAlign = (direction) => direction === 'inbound' || direction === 'internal' ? 'flex-start' : 'flex-end';
  const shownMsgs = msgs.filter((m) => scope === 'all' || (scope === 'to' && m.direction === 'outbound') || (scope === 'from' && m.direction === 'inbound') || (scope === 'internal' && m.direction === 'internal'));
  const scopeHelp = scope === 'from' ? t('cust.chat.helpFrom') : scope === 'to' ? t('cust.chat.helpTo') : scope === 'internal' ? t('cust.chat.helpInternal') : t('cust.chat.helpAll');
  const lineDiscountAmount = (l) => {
    const base = (l.unitPrice || 0) * (l.quantity || 1);
    const discount = Math.max(0, l.discountType === 'amount' ? window.PlummeMoneyInput.number(l.discountValue, 0) : Number(String(l.discountValue || 0).replace(',', '.')) || 0);
    return l.discountType === 'amount' ? Math.min(base, discount) : Math.min(base, base * Math.min(100, discount) / 100);
  };
  const lineNet = (l) => Math.max(0, (l.unitPrice || 0) * (l.quantity || 1) - lineDiscountAmount(l));
  const net = lines.reduce((s, l) => s + lineNet(l), 0);
  const vat = Math.round(lines.reduce((s, l) => s + lineNet(l) * ((l.vatRate || 0) / 100), 0));
  const quoteLineBase = (line) => (line.unitPrice || 0) * (line.quantity || 1);
  const quoteLineDiscountText = (line) => {
    const discount = lineDiscountAmount(line);
    if (discount <= 0) return '';
    const raw = Math.max(0, line.discountType === 'amount' ? window.PlummeMoneyInput.number(line.discountValue, 0) : Number(String(line.discountValue || 0).replace(',', '.')) || 0);
    const label = line.discountType === 'amount' ? fmt(raw) : `${Math.min(100, raw)} %`;
    return `Rabatt: ${label} (-${fmt(discount)})`;
  };
  const quoteLineChatText = (line) => {
    const name = line.description || line.productName || line.name || line.itemNumber || line.productNumber || 'Produkt';
    const qty = line.quantity || 1;
    const discountText = quoteLineDiscountText(line);
    if (!discountText) return `${name}: ${qty} x ${fmt(line.unitPrice || 0)} eks. MVA`;
    return [
      name,
      `Antall: ${qty}`,
      `Fullpris eks. MVA: ${fmt(quoteLineBase(line))}`,
      discountText,
      `Pris etter rabatt eks. MVA: ${fmt(lineNet(line))}`,
    ].join('\n');
  };
  const quoteTotalChatText = () => [
    'Tilbudsgrunnlag total',
    `Sum eks. MVA: ${fmt(net)}`,
    `MVA: ${fmt(vat)}`,
    `Total inkl. MVA: ${fmt(net + vat)}`,
  ].join('\n');
  const quoteBasisChatText = () => [
    'Tilbudsgrunnlag',
    ...lines.map((line, index) => `${index + 1}. ${quoteLineChatText(line).replace(/\n/g, '\n   ')}`),
    '',
    `Sum eks. MVA: ${fmt(net)}`,
    `MVA: ${fmt(vat)}`,
    `Total inkl. MVA: ${fmt(net + vat)}`,
  ].join('\n').trim();
  const insertDraftText = (text, at) => {
    setDraft((current) => {
      const clean = String(text || '').trim();
      if (!clean) return current;
      if (typeof at === 'number') {
        const before = current.slice(0, at);
        const after = current.slice(at);
        const prefix = before && !before.endsWith('\n') ? '\n' : '';
        const suffix = after && !after.startsWith('\n') ? '\n' : '';
        return `${before}${prefix}${clean}${suffix}${after}`.slice(0, 2000);
      }
      const prefix = current.trim() ? `${current.trimEnd()}\n` : '';
      return `${prefix}${clean}`.slice(0, 2000);
    });
  };
  // HTML5-dragging finnes ikke på touch, så mobil får en pointer-basert variant:
  // hold hvor som helst på linjen, dra, og slipp over meldingsfeltet. Musepekere
  // hoppes over — de bruker det vanlige draget fra grep-ikonet.
  const touchDragText = (getText) => (event) => {
    if (event.pointerType === 'mouse') return;
    // Kontroller inne i linjen (antall, rabatt, slett) skal fortsatt kunne trykkes.
    // Sitter handleren på selve kontrollen — som grep-ikonet — er den drahåndtaket.
    const interactive = event.target.closest && event.target.closest('button,input,select,textarea,label,a');
    if (interactive && interactive !== event.currentTarget) return;
    const startX = event.clientX, startY = event.clientY;
    const scroller = event.currentTarget.closest('.modal-bd');
    let ghost = null, lastY = startY, edgeTimer = 0;
    const dropTarget = (x, y) => { const el = document.elementFromPoint(x, y); return el ? el.closest('[data-chat-drop]') : null; };
    const clearMarks = () => document.querySelectorAll('[data-chat-drop]').forEach((el) => el.classList.remove('chat-drop-active'));
    // Slippfeltet ligger over listen og kan være utenfor skjermen — kant-scroll
    // holder det tilgjengelig mens fingeren står stille.
    const edgeScroll = () => {
      if (!ghost || !scroller) return;
      const r = scroller.getBoundingClientRect();
      if (lastY < r.top + 70) scroller.scrollTop -= 14;
      else if (lastY > r.bottom - 70) scroller.scrollTop += 14;
    };
    const move = (ev) => {
      lastY = ev.clientY;
      if (!ghost) {
        if (Math.abs(ev.clientX - startX) < 8 && Math.abs(ev.clientY - startY) < 8) return;
        ghost = document.createElement('div');
        ghost.className = 'chat-drag-ghost';
        ghost.textContent = String(getText() || '').split('\n')[0];
        document.body.appendChild(ghost);
        edgeTimer = window.setInterval(edgeScroll, 60);
      }
      const over = dropTarget(ev.clientX, ev.clientY);
      ghost.style.transform = `translate(${ev.clientX + 14}px, ${ev.clientY - 20}px)`;
      ghost.classList.toggle('over', !!over);
      clearMarks();
      if (over) over.classList.add('chat-drop-active');
    };
    const end = (ev) => {
      window.removeEventListener('pointermove', move);
      window.removeEventListener('pointerup', end);
      window.removeEventListener('pointercancel', end);
      if (edgeTimer) window.clearInterval(edgeTimer);
      clearMarks();
      const over = ghost && ev.type === 'pointerup' ? dropTarget(ev.clientX, ev.clientY) : null;
      if (ghost) ghost.remove();
      if (over) insertDraftText(getText());
    };
    window.addEventListener('pointermove', move);
    window.addEventListener('pointerup', end);
    window.addEventListener('pointercancel', end);
  };
  const persistThread = async (thread) => {
    if (!window.PlummeBackend?.saveCustomerConversationThread) throw new Error(t('cus.chat.notConnected'));
    const updated = await window.PlummeBackend.saveCustomerConversationThread(c.id, thread);
    onCustomerUpdated?.(updated);
    const nextThreads = updated?.conversationThreads || [];
    if (nextThreads.length) setLoadedThreads(nextThreads);
    return nextThreads.find((entry) => entry.id === thread.id) || thread;
  };
  const ensureThread = async () => {
    if (active) return active;
    const thread = window.PlummeBackend?.createCustomerConversationThread
      ? window.PlummeBackend.createCustomerConversationThread('Kundedialog')
      : { id: 'dialog-' + Date.now(), createdAt: new Date().toISOString(), updatedAt: new Date().toISOString(), title: 'Kundedialog', status: 'drafting', messages: [], quoteLines: [] };
    setActiveId(thread.id);
    return persistThread(thread);
  };
  const newDialog = async () => {
    setBusy('dialog');
    try {
      const thread = await persistThread(window.PlummeBackend.createCustomerConversationThread('Kundedialog'));
      setActiveId(thread.id);
      setDlgOpen(false);
      toast(t('cus.chat.newStarted', { date: today }), 'info');
    } catch (error) {
      toast(error?.message || t('cus.chat.newFailed'), 'error');
    } finally {
      setBusy('');
    }
  };
  const updateQuoteLines = async (updater) => {
    setBusy('quote');
    try {
      const thread = await ensureThread();
      const current = thread.quoteLines || [];
      const nextLines = typeof updater === 'function' ? updater(current) : updater;
      await persistThread({ ...thread, status: nextLines.length ? 'ready_for_offer' : 'drafting', quoteLines: nextLines });
    } catch (error) {
      toast(error?.message || t('cus.chat.quoteBasisFailed'), 'error');
    } finally {
      setBusy('');
    }
  };
  const addLine = (p) => {
    updateQuoteLines((ls) => ls.find((l) => l.productId === p.id)
      ? ls.map((l) => l.productId === p.id ? { ...l, quantity: (l.quantity || 1) + 1 } : l)
      : [...ls, {
        id: 'quote-' + Date.now(),
        productId: p.id,
        productName: p.name,
        description: p.desc || p.name,
        itemNumber: p.nr || p.itemNumber || p.productNumber || '',
        productNumber: p.nr || p.itemNumber || p.productNumber || '',
        unitPrice: p.price || 0,
        quantity: 1,
        discountValue: 0,
        discountType: 'percent',
        vatRate: p.vat ?? 25,
        vatTreatment: p.vatTreatment || ((p.vat ?? 25) === 0 ? 'zeroRated' : 'standard'),
        salesAccountCode: p.salesAccountCode || '3000',
        type: p.type,
      }]);
    setQ('');
  };
  const setQty = (id, d) => updateQuoteLines((ls) => ls.map((l) => l.id === id ? { ...l, quantity: Math.max(1, (l.quantity || 1) + d) } : l));
  const setDisc = (id, v) => updateQuoteLines((ls) => ls.map((l) => {
    if (l.id !== id) return l;
    const raw = Math.max(0, l.discountType === 'amount' ? window.PlummeMoneyInput.number(v, 0) : Number(String(v || 0).replace(',', '.')) || 0);
    return { ...l, discountValue: l.discountType === 'amount' ? raw : Math.min(100, raw) };
  }));
  const toggleDiscMode = (id) => updateQuoteLines((ls) => ls.map((l) => {
    if (l.id !== id) return l;
    const nextType = l.discountType === 'amount' ? 'percent' : 'amount';
    return { ...l, discountType: nextType, discountValue: nextType === 'percent' ? Math.min(100, l.discountValue || 0) : (l.discountValue || 0) };
  }));
  const removeLine = (id) => updateQuoteLines((ls) => ls.filter((x) => x.id !== id));
  const lagTilbud = async () => {
    if (!active?.id || !lines.length) return;
    setBusy('offer');
    try {
      const result = await window.PlummeBackend.createOfferFromCustomerConversation(c.id, active.id);
      if (result?.customer) onCustomerUpdated?.(result.customer);
      if (result?.invoice) window.PlummeBackend?.setOpenInvoice?.(result.invoice);
      toast(t('cus.chat.offerCreated', { name: customer.name }), 'success');
      onClose();
      if (setRoute) setRoute('faktura');
    } catch (error) {
      toast(error?.message || t('cus.chat.offerFailed'), 'error');
    } finally {
      setBusy('');
    }
  };
  const saveMessage = async () => {
    const message = draft.trim();
    if (!message) return;
    setBusy('save');
    try {
      const thread = await ensureThread();
      const direction = scope === 'from' ? 'inbound' : scope === 'internal' ? 'internal' : 'outbound';
      const now = new Date().toISOString();
      const updated = await persistThread({
        ...thread,
        status: direction === 'inbound' ? 'customer_waiting' : direction === 'outbound' ? 'waiting_customer' : (thread.quoteLines || []).length ? 'ready_for_offer' : 'drafting',
        messages: [...(thread.messages || []), { id: 'msg-' + Date.now(), createdAt: now, direction, text: message }],
      });
      onCustomerUpdated?.(updated);
      setDraft('');
      toast(direction === 'outbound' ? t('cus.chat.savedInDialog') : direction === 'inbound' ? t('cus.chat.customerMessageSaved') : t('cus.chat.internalNoteSaved'), 'success');
    } catch (error) {
      toast(error?.message || t('cus.chat.saveFailed'), 'error');
    } finally {
      setBusy('');
    }
  };
  const send = async () => {
    const message = draft.trim();
    if (!message) return;
    if (scope === 'from' || scope === 'internal') {
      await saveMessage();
      return;
    }
    setBusy('send');
    try {
      const thread = await ensureThread();
        const result = await window.PlummeBackend.sendCustomerConversationEmail({
          customerId: c.id,
          threadId: thread.id,
          messageText: message,
          subject: thread.title || 'Kundedialog',
        });
        if (result?.customer) onCustomerUpdated?.(result.customer);
        toast(t('cus.chat.sent'), 'success');
      setDraft('');
    } catch (error) {
      toast(error?.message || t('cus.chat.sendFailed'), 'error');
    } finally {
      setBusy('');
    }
  };
  return <Modal open onClose={onClose} title={t('cus.chat.modalTitle', { name: c.name })} max={760}>
    <div className="col gap-16" style={{ paddingBottom: 4 }}>
      <div className="row gap-10 wrap dlg-status-row" style={{ alignItems: 'center' }}>
        <div className="popwrap">
          <button className="btn btn-secondary btn-sm" disabled={!!busy} data-help-title={t('cust.chat.threadsHelpTitle')} data-help={t('cust.chat.threadsHelp')} onClick={() => setDlgOpen((o) => !o)}><Icon name="mail" size={15} />{t('cust.dialogTitle')} · {active ? customerDate(active.updatedAt || active.createdAt) : today}<Icon name="chevDown" size={14} /></button>
          {dlgOpen && <React.Fragment><div className="pop-scrim" onClick={() => setDlgOpen(false)} />
            <div className="pop pop-menu" style={{ minWidth: 260 }}>
              {threads.map((d, i) => <button key={d.id} onClick={() => { setActiveId(d.id); setDlgOpen(false); }}><Icon name="mail" size={15} />{t('cus.chat.dialogN', { n: i + 1, date: customerDate(d.updatedAt || d.createdAt) })}{d.id === active?.id && <Icon name="check" size={16} style={{ marginLeft: 'auto' }} />}</button>)}
              <div className="rowmenu-sep" />
              <button onClick={newDialog}><Icon name="plus" size={15} />{t('cus.chat.newConversation', { date: today })}</button>
            </div></React.Fragment>}
        </div>
        <span className="pp pp-paid" style={{ alignSelf: 'center' }}>{lines.length ? t('cus.chat.readyForQuote') : t('cus.chat.chipDialog')}</span>
      </div>
      <div className="row between" style={{ alignItems: 'center' }}>
        <b className="t-h3" style={{ fontSize: 15 }}>{t('cust.chat.conversation')}</b>
        <Select value={scope} onChange={(e) => setScope(e.target.value)} style={{ width: 210 }} data-help-title={t('cust.chat.filterTitle')} data-help={t('cust.chat.filterHelp')}>{SCOPES.map((o) => <option key={o} value={o}>{scopeLabel(o)}</option>)}</Select>
      </div>
      <div className="t-sm muted" style={{ fontWeight: 600, marginTop: -6 }}>{scopeHelp}</div>
      <div className="panel" data-help-title={t('cust.chat.windowTitle')} data-help={t('cust.chat.windowHelp')} style={{ padding: 14, minHeight: 150, height: 260, maxHeight: '60vh', resize: 'vertical', overflow: 'auto', display: 'flex', flexDirection: 'column', gap: 10 }}>
        {shownMsgs.length === 0 && <div className="t-sm muted" style={{ margin: 'auto', fontWeight: 600 }}>{t('cus.chat.noMessages')}</div>}
        {shownMsgs.map((m) => <div key={m.id} style={{ alignSelf: messageAlign(m.direction), maxWidth: '78%', background: m.direction === 'internal' ? 'var(--plum-50)' : 'var(--card)', border: '1px solid ' + (m.direction === 'internal' ? 'var(--plum-200)' : 'var(--border)'), borderRadius: m.direction === 'outbound' ? 'var(--r-md) var(--r-md) var(--r-3xs) var(--r-md)' : 'var(--r-md) var(--r-md) var(--r-md) var(--r-3xs)', padding: '10px 13px' }}>
          <div className="t-xs muted" style={{ fontWeight: 800, marginBottom: 3 }}>{messageLabel(m.direction)} · {customerDate(m.createdAt)}</div>
          <div className="t-sm" style={{ fontWeight: 600, color: 'var(--ink-2)' }}>{m.text}</div>
        </div>)}
      </div>
      <div className="fak-box" data-help-title={t('cust.chat.newTitle')} data-help={t('cust.chat.newHelp')}>
        <div className="row between" style={{ marginBottom: 8 }}>
          <b className="t-h3" style={{ fontSize: 15 }}>{t(scope === 'internal' ? 'cust.chat.newInternalTitle' : 'cust.chat.newTitle')}</b>
        </div>
        <textarea className="input" ref={messageTextareaRef} data-chat-drop rows="3" value={draft} maxLength={2000} onChange={(e) => setDraft(e.target.value)} placeholder={t('cust.chat.draftPh')}
          onDragOver={(e) => { if (e.dataTransfer.types.includes('text/plain')) e.preventDefault(); }}
          onDrop={(e) => {
            const text = e.dataTransfer.getData('text/plain');
            if (!text) return;
            e.preventDefault();
            insertDraftText(text, e.currentTarget.selectionStart);
          }} />
        <div className="row between wrap gap-10 msg-actions-row" style={{ marginTop: 8 }}>
          <span className="t-xs muted" style={{ fontWeight: 700 }}>{draft.length} / 2000</span>
          <div className="row gap-10">
            <Button variant="secondary" icon="plus" disabled={!!busy} onClick={newDialog}>{t('cust.chat.newDialog')}</Button>
            <Button icon={scope === 'internal' || scope === 'from' ? 'check' : 'send'} disabled={!!busy || !draft.trim()} onClick={send}>{t(scope === 'internal' ? 'cust.chat.saveInDialog' : scope === 'from' ? 'cust.chat.saveMessage' : 'cust.chat.sendMessage')}</Button>
          </div>
        </div>
      </div>
      <div className="fak-box" data-help-title={t('cust.chat.quoteTitle')} data-help={t('cust.chat.quoteHelp')}>
        <div className="row between gap-10 wrap" style={{ alignItems: 'center' }}>
          <b className="t-h3" style={{ fontSize: 15 }}>{t('cust.chat.quoteTitle')}</b>
          {lines.length > 0 && <button type="button" className="btn btn-secondary btn-sm" title={t('cust.chat.dragBasis')} draggable onDragStart={(e) => { e.dataTransfer.effectAllowed = 'copy'; e.dataTransfer.setData('text/plain', quoteBasisChatText()); }} onPointerDown={touchDragText(quoteBasisChatText)} onClick={() => insertDraftText(quoteBasisChatText())}><Icon name="grip" size={15} />{t('cust.chat.quoteBasis')}</button>}
        </div>
        <Field label={t('cust.chat.findProduct')} className="mt-10"><div style={{ position: 'relative' }}>
          <Input icon="search" value={q} onChange={(e) => setQ(e.target.value)} placeholder={t('cust.chat.productPh')} />
          {prods.length > 0 && <div className="card" style={{ position: 'absolute', top: 46, left: 0, right: 0, zIndex: 20, padding: 6, boxShadow: 'var(--sh-lg)' }}>
            {prods.map((p) => <button key={p.id} className="sb-item" style={{ margin: 0, justifyContent: 'space-between' }} onClick={() => addLine(p)}><span>{p.name}</span><span className="t-sm muted">{fmt(p.price)}</span></button>)}
          </div>}
        </div></Field>
        {lines.length > 0 && <div className="col gap-8 mt-12">{lines.map((l) => <div key={l.id} className="chatline" onPointerDown={touchDragText(() => quoteLineChatText(l))}>
          <div className="row gap-10" style={{ minWidth: 0, flex: 1 }}><button type="button" className="chatline-del" title={t('cust.chat.dragToMessage')} draggable onDragStart={(e) => { e.dataTransfer.effectAllowed = 'copy'; e.dataTransfer.setData('text/plain', quoteLineChatText(l)); }} onClick={() => insertDraftText(quoteLineChatText(l))}><Icon name="grip" size={16} /></button><div style={{ minWidth: 0 }}><div className="t-h3" style={{ fontSize: 13.5, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{l.productName || l.description}</div><div className="t-sm muted">{fmt(l.unitPrice)}{l.discountValue > 0 && <span style={{ color: 'var(--success)', fontWeight: 800 }}> · -{l.discountType === 'amount' ? fmt(l.discountValue) : l.discountValue + '%'}</span>}</div></div></div>
          <div className="chatline-controls">
            <div className="qty-input"><button disabled={busy === 'quote'} onClick={() => setQty(l.id, -1)}>-</button><span>{l.quantity || 1}</span><button disabled={busy === 'quote'} onClick={() => setQty(l.id, 1)}>+</button></div>
            <label className="chatline-disc input-affix" style={{ width: 96 }}><Input className="input" inputMode="decimal" value={l.discountValue || 0} onChange={(e) => setDisc(l.id, e.target.value)} /><button type="button" className="affix affix-btn" onClick={() => toggleDiscMode(l.id)}>{l.discountType === 'amount' ? 'kr' : '%'}</button></label>
            <b className="t-num" style={{ minWidth: 78, textAlign: 'right' }}>{fmt(lineNet(l))}</b>
            <button className="chatline-del" title={t('cust.chat.remove')} disabled={busy === 'quote'} onClick={() => removeLine(l.id)}><Icon name="x" size={15} /></button>
          </div>
        </div>)}</div>}
        <div className="kv mt-12">
          <div className="kv-row"><span className="kv-key">{t('cus.chat.sumExVat')}</span><span className="kv-val">{fmt(net)}</span></div>
          <div className="kv-row"><span className="kv-key">{t('cus.chat.vat25')}</span><span className="kv-val">{fmt(vat)}</span></div>
          <div className="kv-row chat-total-row"><span className="kv-key" style={{ fontWeight: 900 }}>{t('cust.chat.total')}</span><span className="row gap-8"><button type="button" className="chatline-del" title={t('cust.chat.dragTotal')} draggable onDragStart={(e) => { e.dataTransfer.effectAllowed = 'copy'; e.dataTransfer.setData('text/plain', quoteTotalChatText()); }} onClick={() => insertDraftText(quoteTotalChatText())}><Icon name="grip" size={16} /></button><span className="kv-val" style={{ fontWeight: 900 }}>{fmt(net + vat)}</span></span></div>
        </div>
        <Button className="btn-block mt-14" icon="fileText" disabled={lines.length === 0 || !!busy} onClick={lagTilbud}>{t('cust.chat.makeQuote')}</Button>
      </div>
    </div>
  </Modal>;
}

Object.assign(window, { KunderPage, CustomerChatModal });
